export enum HomeVariant {
    BASE = 'base',
    WITH_FAQS = 'with_faqs',
}
